/** @format */

import React, { FunctionComponent } from 'react';
import GetSubscriptionView from './GetSubscriptionView';
import GetCurrencyBalanceForSubscriptionView from './GetCurrencyBalanceForSubscriptionView';
import GetAccountForSubscriptionView from './GetAccountForSubscriptionView';
import GetFeatureDetailsForSubscriptionView from './GetFeatureDetailsForSubscriptionView';
import GetFeatureUsageForSubscriptionView from './GetFeatureUsageForSubscriptionView';
import GetFeaturesForSubscriptionView from './GetFeaturesForSubscriptionView';
import ClientSubscrActivateSubscrView from './ClientSubscrActivateSubscrView';
import ClientSubscrCreateAdjustmentView from './ClientSubscrCreateAdjustmentView';
import ClientSubscrChangeSimcardView from './ClientSubscrChangeSimcardView';
import MvnoOperation from '../../interfaces/platform/MvnoOperation';
import ClientSubscrPrepaidPortingSetView from './ClientSubscrPrepaidPortingSetView';
import ClientSubscrContractSetView from './ClientSubscrContractSetView';
import ClientSubscrChangeStatusView from './ClientSubscrChangeStatusView';
import ClientSubscrActivateVoicemailView from './ClientSubscrActivateVoicemailView';
import ClientSubscrChangeApnView from './ClientSubscrChangeApnView';
import ClientSubscrChangeGPRSView from './ClientSubscrChangeGPRSView';
import ClientSubscrChangeMsisdnView from './ClientSubscrChangeMsisdnView';
import ClientSubscrChangeNetworkserviceView from './ClientSubscrChangeNetworkserviceView';
import ClientSubscrChangePromotionView from './ClientSubscrChangePromotionView';
import ClientSubscrChangeRoamingView from './ClientSubscrChangeRoamingView';
import ClientSubscrChangeTariffView from './ClientSubscrChangeTariffView';
import ClientSubscrRemovePackageView from './ClientSubscrRemovePackageView';
import ClientSubscrRemoveVoicemailView from './ClientSubscrRemoveVoicemailView';
import ClientSubscrResetVMPasswordView from './ClientSubscrResetVMPasswordView';
import ClientSubscrUpdateBprView from './ClientSubscrUpdateBprView';
import ClientSubscrUpdateCustomerView from './ClientSubscrUpdateCustomerView';
import ClientSubscrUpdateDetailsView from './ClientSubscrUpdateDetailsView';
import ClientSubscrAddPackageView from './ClientSubscrAddPackageView';

export type PlkViewObjectType = {
    mvnoOperation: MvnoOperation;
    viewDialog(title: any | string | null, content: any | null): void;
};

export const PlkViewObject: FunctionComponent<PlkViewObjectType> = ({ mvnoOperation, viewDialog }) => {
    switch (mvnoOperation.command) {
        case 'getSubscription':
            return <GetSubscriptionView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />;
        case 'getCurrencyBalanceForSubscription':
            return (
                <GetCurrencyBalanceForSubscriptionView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'getAccountForSubscription':
            return (
                <GetAccountForSubscriptionView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'getFeatureDetailsForSubscription':
            return (
                <GetFeatureDetailsForSubscriptionView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'getFeatureUsageForSubscription':
            return (
                <GetFeatureUsageForSubscriptionView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'getFeaturesForSubscription':
            return (
                <GetFeaturesForSubscriptionView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );

        case 'ClientSubscrActivateSubscr':
            return (
                <ClientSubscrActivateSubscrView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrReloadAccount':
            return (
                <ClientSubscrActivateSubscrView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrCreateAdjustment':
            return (
                <ClientSubscrCreateAdjustmentView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'ClientSubscrChangeSimcard':
            return (
                <ClientSubscrChangeSimcardView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrPrepaidPortingSet':
            return (
                <ClientSubscrPrepaidPortingSetView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'ClientSubscrContractSet':
            return <ClientSubscrContractSetView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />;
        case 'ClientSubscrChangeStatus':
            return (
                <ClientSubscrChangeStatusView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrActivateVoicemail':
            return (
                <ClientSubscrActivateVoicemailView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'ClientSubscrChangeApn':
            return <ClientSubscrChangeApnView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />;
        case 'ClientSubscrChangeGPRS':
            return <ClientSubscrChangeGPRSView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />;
        case 'ClientSubscrChangeMsisdn':
            return (
                <ClientSubscrChangeMsisdnView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrChangeNetworkservice':
            return (
                <ClientSubscrChangeNetworkserviceView
                    key={'mvno_operation_view_block_' + mvnoOperation.id}
                    item={mvnoOperation}
                    viewDialog={viewDialog}
                />
            );
        case 'ClientSubscrChangePromotion':
            return (
                <ClientSubscrChangePromotionView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrChangeRoaming':
            return (
                <ClientSubscrChangeRoamingView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrChangeTariff':
            return (
                <ClientSubscrChangeTariffView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrRemovePackage':
            return (
                <ClientSubscrRemovePackageView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrRemoveVoicemail':
            return (
                <ClientSubscrRemoveVoicemailView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrResetVMPassword':
            return (
                <ClientSubscrResetVMPasswordView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrUpdateBpr':
            return <ClientSubscrUpdateBprView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />;
        case 'ClientSubscrUpdateCustomer':
            return (
                <ClientSubscrUpdateCustomerView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrUpdateDetails':
            return (
                <ClientSubscrUpdateDetailsView key={'mvno_operation_view_block_' + mvnoOperation.id} item={mvnoOperation} viewDialog={viewDialog} />
            );
        case 'ClientSubscrAddPackage':
            return <ClientSubscrAddPackageView item={mvnoOperation} viewDialog={viewDialog} key={'mvno_operation_view_block_' + mvnoOperation.id} />;
        default:
            return null;
    }
};
